import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Row, Col } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'

import styles from './styles.module.scss'
import { payload } from '@shared/libs/category'
import { isBottomReached } from '@shared-submodule/utils'
import { GET_TAG_ARTICLE } from '@graphql/tag/tag.query'
import { articleLoader } from '@shared/libs/allLoader'
import useWindowSize from '@shared/hooks/windowSize'
import LazyLoad from '@shared/components/lazyLoad'

const ArticleSearch = dynamic(() => import('@shared/components/article/articleSearch'), { loading: () => articleLoader(['g']) })

const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

const TeamNews = ({ data, category, hideBadge, isClientOnly, teamData }) => {
  const [newsData, setNewsData] = useState(data?.aResults || [])
  const loading = useRef(false)
  const payloadNews = useRef({ ...payload(7) })
  const [isLoading, setIsLoading] = useState(false)
  const [width] = useWindowSize()

  const [tagArticle, { data: tagArticles, tLoading }] = useLazyQuery(GET_TAG_ARTICLE)

  const latestNews = useRef(getLengthForPagination())

  useEffect(() => {
    loading.current = false
    setIsLoading(false)
    latestNews.current = getLengthForPagination()
    if (newsData?.length) isBottomReached(newsData[newsData.length - 1]?._id, isReached)
  }, [newsData])

  useEffect(() => {
    const value = tagArticles?.getTagArticlesFront
    if (value && value?.aResults?.length !== 0) {
      setNewsData([...newsData, ...value?.aResults])
    }
  }, [tagArticles])

  async function isReached(reach) {
    if (reach && !loading.current && (latestNews.current === 7 || latestNews.current === newsData?.length - 1)) {
      setIsLoading(true)
      loading.current = true
      setPayload()
      getMoreData()
    }
  }

  async function getMoreData() {
    const { data } = await tagArticle({ variables: { input: { _id: teamData?._id, eType: 't', ...payloadNews.current } } })
    return data?.getTagArticlesFront?.aResults
  }

  function setPayload(isTag) {
    payloadNews.current = { ...payloadNews.current, eType: 'p', nSkip: payloadNews.current.nSkip + 1 }
  }

  function getLengthForPagination() {
    return (
      tagArticles?.getTagArticlesFront?.aResults?.length ||
      data?.aResults?.length
    )
  }

  return (
    <>
      {newsData?.length !== 0 && (
        <div className={styles.seriesHome}>
          <Row>
            {newsData?.map((news, i) => {
              if (width < 768) {
                if (i < 2) {
                  return (
                    <React.Fragment key={i + news?._id}>
                      <Col lg={4} sm={6} id={news?._id}>
                        <ArticleSearch data={news} isVideo={news?.__typename === 'oVideoData'} />
                      </Col>
                    </React.Fragment>
                  )
                } else {
                  return (
                    <LazyLoad key={i + news?._id}>
                      <React.Fragment key={i + news?._id}>
                        <Col lg={4} sm={6} id={news?._id}>
                          <ArticleSearch data={news} isVideo={news?.__typename === 'oVideoData'} />
                        </Col>
                      </React.Fragment>
                    </LazyLoad>
                  )
                }
              } else {
                if (i < 6) {
                  return (
                    <React.Fragment key={i + news?._id}>
                      <Col lg={4} sm={6} id={news?._id}>
                        <ArticleSearch data={news} isVideo={news?.__typename === 'oVideoData'} />
                      </Col>
                    </React.Fragment>
                  )
                } else {
                  return (
                    <LazyLoad key={i + news?._id}>
                      <React.Fragment key={i + news?._id}>
                        <Col lg={4} sm={6} id={news?._id}>
                          <ArticleSearch data={news} isVideo={news?.__typename === 'oVideoData'} />
                        </Col>
                      </React.Fragment>
                    </LazyLoad>
                  )
                }
              }
            })}
          </Row>
          {isLoading && articleLoader(['s', 's'])}
        </div>
      )}
      {(!tLoading || !isLoading) && newsData?.length === 0 && <NoData />}
    </>
  )
}

TeamNews.propTypes = {
  data: PropTypes.object,
  category: PropTypes.object,
  teamData: PropTypes.object,
  hideBadge: PropTypes.bool,
  isClientOnly: PropTypes.bool
}

export default TeamNews
